export class ProductForm extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['submit']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))

    this.handlePurpleDotShippingInfo()
    this.setupPreorderWatcher()
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form)
  }

  handlePurpleDotShippingInfo () {
    const observerConfig = {
      childList: true,
      subtree: true,
    }

    const deliveryNoteEl = document.querySelector(
      '[data-product-form-el="preorder-note"]',
    )
    if (!deliveryNoteEl) return

    const mutationObserver = new MutationObserver(
      this.handleMutationInjected.bind(this),
    )

    mutationObserver.observe(this, observerConfig)
  }

  handleMutationInjected (mutationsList, observer) {
    mutationsList.forEach((mutation) => {
      const addedNode = mutation.addedNodes[0]
      if (addedNode?.id === 'pd-waitlist-info') {
        const textEl = addedNode.querySelector('#pd-dispatch-date')
        const mainProduct = mutation.target.closest('.prd-Detail')
        if (!textEl || !mainProduct) return

        const el = document.createElement('p')
        el.classList.add('prd-Note_Text')
        el.innerText = textEl.innerText

        const deliveryNoteEl = document.querySelector(
          '[data-product-form-el="preorder-note"]',
        )

        deliveryNoteEl.insertAdjacentElement('beforeend', el)

        observer.disconnect()
      }
    })
  }

  setupPreorderWatcher () {
    const mainProductForm = document.querySelector('form[data-push-cart-form]')
    if (!mainProductForm) return

    this.preorderObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          this.handlePreorderClassChange(mainProductForm)
        }
      })
    })

    this.preorderObserver.observe(mainProductForm, {
      attributes: true,
      attributeFilter: ['class'],
    })

    this.handlePreorderClassChange(mainProductForm)
  }

  handlePreorderClassChange (mainProductForm) {
    const isPreorder = mainProductForm.classList.contains(
      'x-pd-atc-form--preorder',
    )
    this.updateButtonTextForPreorder(isPreorder)
  }

  updateButtonTextForPreorder (isPreorder) {
    const addToCartText = this.els.submit.element.querySelector(
      '[data-product-add-to-cart-text]',
    )

    if (!addToCartText) return

    if (isPreorder) {
      addToCartText.dataset.text =
        window.variantStrings?.preOrder || 'Pre-Order'
    }
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
